import React from "react";
import styled from "styled-components";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Logo1 from "../../Component/Images/metaLogo.png";
import Logo2 from "../../Component/Images/GPMLogo.png";
import Logo3 from "../../Component/Images/bb-logo-2.png";
import Logo4 from "../../Component/Images/vuezen-logo.png";
import Logo5 from "../../Component/Images/sheluxeLogo.png";
import Logo6 from "../../Component/Images/sheRealLogo.png";
import Logo7 from "../../Component/Images/colexionLogo.png";
import Logo8 from "../../Component/Images/mondus.png";
import Logo9 from "../../Component/Images/floxytravel.png";
import Logo10 from "../../Component/Images/PSEBblack.png";
import Logo11 from "../../Component/Images/DRDO.png";
import "./BelivingCompanies.css";
import Marquee from "react-fast-marquee";

const Root = styled.div`
  width: 100%;
  background-color: #fafbff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const CardWrapper = styled.div`
  font-family: Instrument Sans;
  margin-top: -5% !important;
  padding: 20px 70px;
  min-height: 170px !important;
  box-shadow: 0px 0px 15px 1px rgb(0 0 0 / 23%);
  border-radius: 6px;

  width: 80%;
  margin-top: 45px;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  position: relative;
  z-index: 10;

  @media (min-width: 2560px) {
    // width:91%;
    margin-top: -4% !important;
  }
  @media (min-width: 2500px) {
    // width:95%;
    margin-top: -4% !important;
  }

  @media (min-width: 2300px) {
    // width:91%;
    margin-top: -4% !important;
  }
  @media (min-width: 2200px) {
    // width:91%;
    margin-top: -4% !important;
  }

  @media (max-width: 1500px) {
    width: 91%;
    margin-top: -7% !important;
  }
  @media (max-width: 1350px) {
    width: 91%;
    margin-top: -8% !important;
  }
  @media (max-width: 1024px) {
    width: 91%;
    margin: 40px 30px 0 30px;
    padding: 30px 50px;
    margin-top: -11% !important;
  }
  @media (max-width: 768px) {
    width: 91%;
    margin: -80px 30px 0 30px;
    padding: 30px 20px;
    margin-top: -12% !important;
  }
  @media (max-width: 700px) {
    margin-top: -15% !important;
  }
  @media (max-width: 600px) {
    margin-top: -17% !important;
  }

  @media (max-width: 426px) {
    margin-top: -26% !important;
  }
`;

const Text = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: #686868;
  text-align: center;
  margin-bottom: 20px;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 100px;
  // overflow: hidden;
  margin: auto;
`;

const Image = styled.img`
  max-height: ${({ $maxHeight }) => $maxHeight || "75px"};
  width: 100%;
  height: auto;
  max-width: ${({ $maxWidth }) => $maxWidth || "200px"};
  object-fit: contain;
`;

function BelievingCompanies() {
  const logos = [
    { src: Logo11, maxHeight: "90px" },
    { src: Logo10, maxWidth: "300px" },
    { src: Logo2, maxHeight: "90px" },
    { src: Logo1, maxHeight: "90px" },
    { src: Logo3, maxWidth: "220px" },
    { src: Logo4 },
    { src: Logo5, maxHeight: "50px" },
    { src: Logo6 },
    { src: Logo7, maxHeight: "80px" },
    { src: Logo8 },
  ];

  const options = {
    loop: true,
    margin: 10,
    nav: false,
    dots: false,
    // autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: false,
    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 2,
      },
      768: {
        items: 3,
      },
      1024: {
        items: 4,
      },
      1280: {
        items: 5,
      },
    },
  };

  return (
    <Root>
      <CardWrapper>
        <Text>World's top-class companies believing us!</Text>
        {/* <OwlCarousel className="owl-theme" {...options}>
          {logos.map((logo, index) => (
            <div key={index} className="item">
              <ImageWrapper className={`logo-${index + 1}`}>
                <Image  src={logo?.src} alt={`Logo ${index + 1}`}  $maxHeight={logo?.maxHeight}   $maxWidth={logo?.maxWidth}  />
              </ImageWrapper>
            </div>
          ))}
        </OwlCarousel> */}
        {/* <div className="logoCarouselDiv" id="lcarousel">
          <div className="logoCarousel">
            {logos.map((logo, index) => (
              <div key={index} className="item">
                <ImageWrapper className={`logo-${index + 1}`}>
                  <Image
                    src={logo?.src}
                    alt={`Logo ${index + 1}`}
                    $maxHeight={logo?.maxHeight}
                    $maxWidth={logo?.maxWidth}
                    style={{width:"auto"}}
                  />
                </ImageWrapper>
              </div>
            ))}
          </div>
        </div> */}
        <Marquee 
        speed={30}>
{logos.map((logo, index) => (
              <div key={index} className="item" id="brandItem">
                <ImageWrapper className={`logo-${index + 1}`}>
                  <Image
                    src={logo?.src}
                    alt={`Logo ${index + 1}`}
                    $maxHeight={logo?.maxHeight}
                    $maxWidth={logo?.maxWidth}
                    style={{width:"auto"}}
                  />
                </ImageWrapper>
              </div>
            ))}
        </Marquee>
      </CardWrapper>
    </Root>
  );
}

export default BelievingCompanies;
